import { DialogActions, styled } from "@mui/material";
import React from "react";
import { DialogActionsProps } from "@mui/material/DialogActions/DialogActions";
import { pxToRem } from "../../../../utils/fontSizeUtility";

export const WorkspaceActions = styled(
  DialogActions,
  {}
)<DialogActionsProps>(({ theme }) => ({
  paddingTop: pxToRem(20),
  paddingBottom: pxToRem(24),
  paddingRight: pxToRem(24),
  paddingLeft: pxToRem(24),
  backgroundColor: theme.palette.background.paper,
  backgroundImage: "unset",
})) as React.ComponentType<DialogActionsProps>;
